import { http, HttpResponse } from 'msw';
const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/organization_users`;

const base64Image =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAIAAAD/gAIDAAABKUlEQVR4nOzdsQnCUBhGUZUs4XxWTmTlfLYZwQkiuY/gUzinTRMuf/URyLKu64l9LrNf4J+IFYgViBWIFYgViBUsWw9u99d33+RXPB/XrUcuKxArECsQKxArECsQKxArECsQKxArECsQKxArECsQK9gc/wZ8mM0mOnDFdFmBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYwZF7Vl2OBvavuZ/YuaxArECsQKxArECsQKxArECsQKxArECsQKxArECsQKxg5sdsA0ve3L3QZQViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWIFYgViBWe/v9rPZQViBWIFYgViBWIFYgViBe8AAAD//+iwFyUhdusXAAAAAElFTkSuQmCC';

const invalidTokenMessage = '不正なトークンです。';

type OrganizationUsersRecordType = Required<{
  id: number;
  status: string;
  name: string;
  user_id: number;
  speciality: string | null;
  job_category: string | null;
  data_analysis_experience: string | null;
  icon_image_url: string | null;
  identicon: string;
  logo_url: string | null;
  permitted_services: {
    quest: boolean;
    competition: boolean;
    dx_copilot_planner: boolean;
    dx_copilot_analytics: boolean;
  };
}>;

const organizationUsersRecords: OrganizationUsersRecordType[] = [
  {
    id: 1,
    status: 'active',
    name: 'しぐねいと',
    user_id: 1,
    speciality: 'non_technical',
    job_category: 'ai_data',
    data_analysis_experience: 'within_year',
    icon_image_url: null,
    // icon_image_url: 'http://via.placeholder.com/100x100',
    identicon: base64Image,
    logo_url: null,
    // logo_url: 'http://via.placeholder.com/384x92',
    permitted_services: {
      quest: true,
      competition: true,
      dx_copilot_planner: true,
      dx_copilot_analytics: true,
    },
  },
];

const organizationUsersSpecialNotesRecords: string[] = [
  'ユーザー規約特記事項1',
  'ユーザー規約特記事項2\n改行あり',
  '長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項長いユーザー規約特記事項',
];

const organizationUsersLicensesRecords = [
  {
    name: 'ライセンス1',
    starts_at: '2023-01-01T01:00:00+09:00',
    ends_at: '2023-04-01T10:00:00+09:00',
  },
  {
    name: 'ライセンス2',
    starts_at: '2025-01-01T01:00:00+09:00',
    ends_at: '2025-09-30T10:00:00+09:00',
  },
];

export const organizationUsersHandlers = [
  // TODO: ダッシュボード実装時に、ヘッダー表示に必要な情報を設定
  // 自身の(組織ユーザー)情報取得
  http.get(`${baseUrl}/me`, (_) => {
    return HttpResponse.json(organizationUsersRecords[0]);

    // adnmin-appの実装を踏襲
    // return HttpResponse.json(
    //   { error_type: 'error', message: 'サインインしてください' },
    //   { status: 401 }
    // );
  }),
  http.get(`${baseUrl}/me/special_notes`, (_) => {
    return HttpResponse.json(organizationUsersSpecialNotesRecords);
  }),
  // 自身の組織ユーザのライセンス情報取得
  http.get(`${baseUrl}/me/licenses`, (_) => {
    return HttpResponse.json(organizationUsersLicensesRecords);
  }),
  // パスワード設定
  http.post(`${baseUrl}/create_user_password`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      token: string;
      password: string;
      password_confirmation: string;
    };
    console.info(postRequest);

    if (postRequest.password === 'errorpass') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'password',
              message: 'パスワードを正しい書式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    } else if (postRequest.password_confirmation === 'errorpassword') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'password_confirmation',
              message: 'パスワード（確認）を正しい書式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    } else if (
      postRequest.token === 'valid_token' &&
      postRequest.password &&
      postRequest.password_confirmation
    ) {
      const response = { success: true };
      console.info(response);

      return HttpResponse.json(response);
    } else {
      return HttpResponse.json(
        { error_type: 'error', message: invalidTokenMessage },
        { status: 400 }
      );
    }
  }),
  // 招待受領(非個人向け組織)または本登録(個人向け組織)
  http.post(`${baseUrl}/accept_invitation`, async ({ request }) => {
    const postRequest = (await request.formData()) as FormData;
    console.info(...postRequest.entries());

    if (postRequest.get('token') === 'errorToken') {
      return HttpResponse.json(
        { error_type: 'error', message: invalidTokenMessage },
        { status: 400 }
      );
    } else if (postRequest.get('name') === 'error') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'name',
              message: 'ニックネームを正しい書式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    } else if (
      postRequest.get('token') === 'individualToken' ||
      (postRequest.get('name') &&
        postRequest.get('speciality') &&
        postRequest.get('job_category') &&
        postRequest.get('data_analysis_experience'))
    ) {
      const response = { success: true };
      console.info(response);

      return HttpResponse.json(response);
    } else {
      return HttpResponse.json(
        { error_type: 'error', message: '入力エラーです。' },
        { status: 400 }
      );
    }
  }),
  // 招待を受けた組織ユーザー及び登録済み組織ユーザーの情報
  http.post(`${baseUrl}/invited_and_active`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      token: string;
    };
    console.info(postRequest);

    const quest_organization = {
      suspend_weekly_report: false,
      suspend_notification: false,
      suspend_notification_log: false,
    };

    if (postRequest.token === 'errorToken') {
      return HttpResponse.json(
        { error_type: 'error', message: invalidTokenMessage },
        { status: 400 }
      );
    } else if (postRequest.token === 'individualToken') {
      const response = {
        invited_organization_user: {
          identicon: base64Image,
          organization: { sso_only: false, for_individuals: true },
        },
        password_required: true,
        special_notes: organizationUsersSpecialNotesRecords,
      };
      console.info(response);

      return HttpResponse.json(response);
    } else if (postRequest.token === 'ssoToken') {
      const response = {
        invited_organization_user: {
          identicon: base64Image,
          organization: { sso_only: true, for_individuals: false },
        },
        password_required: true,
        special_notes: organizationUsersSpecialNotesRecords,
      };
      console.info(response);

      return HttpResponse.json(response);
    } else if (postRequest.token === 'existingUserToken') {
      const response = {
        invited_organization_user: {
          identicon: base64Image,
          organization: { sso_only: false, for_individuals: false },
        },
        active_organization_user: {
          name: 'しぐねいと',
          speciality: 'technical',
          job_category: 'ai_data',
          data_analysis_experience: 'more_than_year',
        },
        password_required: false,
        special_notes: organizationUsersSpecialNotesRecords,
        quest_organization,
      };
      console.info(response);

      return HttpResponse.json(response);
    } else {
      const response = {
        invited_organization_user: {
          identicon: base64Image,
          organization: { sso_only: false, for_individuals: false },
        },
        password_required: true,
        special_notes: organizationUsersSpecialNotesRecords,
        quest_organization,
      };
      console.info(response);

      return HttpResponse.json(response);
    }
  }),
  // 自身の(組織ユーザ)情報更新
  http.put(`${baseUrl}/me`, async ({ request }) => {
    const organizationUser = organizationUsersRecords[0];
    const updateRequest = (await request.formData()) as FormData;
    console.info(...updateRequest.entries());

    if (updateRequest.get('name') === 'error') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            { field: 'name', message: '正しい組織名を入力してください。' },
          ],
        },
        { status: 400 }
      );
    } else {
      const response = {
        id: organizationUser.id,
        status: organizationUser.status,
        name: organizationUser.name,
        user_id: organizationUser.user_id,
        speciality: organizationUser.speciality,
        job_category: organizationUser.job_category,
        data_analysis_experience: organizationUser.data_analysis_experience,
        icon_image_url: organizationUser.icon_image_url,
        identicon: organizationUser.identicon,
        permitted_services: organizationUser.permitted_services,
      };
      console.info(response);

      return HttpResponse.json(response);
    }
  }),
  // 招待トークンの有効性チェック
  http.post(`${baseUrl}/validate_invitation_token`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      token: string;
    };
    console.info(request);

    if (postRequest.token === 'invalid_token') {
      return HttpResponse.json(
        { error_type: 'error', message: invalidTokenMessage },
        { status: 400 }
      );
    } else {
      return new HttpResponse(null, { status: 200 });
    }
  }),
];
